import Vue from 'vue';
import Vuex from 'vuex';
import { DEALER_SELECTION_MUTATIONS } from './mutations';

Vue.use(Vuex);

const state = {
    projectId: null,
    zipCode: null,
    selectedDealer: null,
};

export const dealerSelectionStore = new Vuex.Store({
    state,
    mutations: {
        [DEALER_SELECTION_MUTATIONS.SET_PROJECT_ID](state, projectId) {
            state.projectId = projectId;
        },
        [DEALER_SELECTION_MUTATIONS.SET_ZIP_CODE](state, zipCode) {
            state.zipCode = zipCode;
        },
        [DEALER_SELECTION_MUTATIONS.SET_SELECTED_DEALER](state, selectedDealer) {
            state.selectedDealer = selectedDealer;
        },
    },
});
